import { Component, EventEmitter, Input, Output } from '@angular/core'
import { TbButtonComponent } from '@components-library/tb-button/tb-button.component'

@Component({
    selector: 'app-pinned-record',
    templateUrl: './pin-record.component.html',
    styleUrls: ['./pin-record.component.sass'],
    imports: [TbButtonComponent],
})
export class PinRecordComponent {
    @Input()
    name!: string

    @Output()
    delete = new EventEmitter()

    @Output()
    openRecord = new EventEmitter()

    openPinItem() {
        this.openRecord.emit()
    }

    removePinItem() {
        this.delete.emit()
    }
}
